export default __webpack_public_path__ + "static/media/1.8f95cea1.png";